module.exports = __webpack_public_path__ + "img/cercle-shape.400c224e.png";